import { getStorageItem } from "./local-storage";

// Returns authorization header with jwt token
export function authHeader() {
  let user = getStorageItem("user");
  if (user && user.accessToken) {
    return { Authorization: "Bearer " + user.accessToken };
  } else {
    return {};
  }
}
